import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { createAppI18n } from './catalogs';
import { getStaticBuildLocale, type MessageLocale } from './locales';

const crashRecoveryMessages = {
    recovering: msg({
        id: 'crashrecoveryboundary.recoveringFromACrash',
        message: 'Recovering from a crash...',
        comment: 'UI copy in components/CrashRecoveryBoundary.tsx',
    }),
    title: msg({
        id: 'crashrecoveryboundary.somethingWentWrong',
        message: 'Something went wrong',
        comment: 'UI copy in components/CrashRecoveryBoundary.tsx',
    }),
    description: msg({
        id: 'crashrecoveryboundary.paperzillaHitAnUnexpectedErrorReloadToRecover',
        message: 'Paperzilla hit an unexpected error. Reload to recover.',
        comment: 'UI copy in components/CrashRecoveryBoundary.tsx',
    }),
    reload: msg({
        id: 'crashrecoveryboundary.reload',
        message: 'Reload',
        comment: 'UI copy in components/CrashRecoveryBoundary.tsx',
    }),
} satisfies Record<string, MessageDescriptor>;

export type CrashRecoveryCopy = {
    recovering: string;
    title: string;
    description: string;
    reload: string;
};

/**
 * Resolves recovery copy without React's Lingui context.
 *
 * CrashRecoveryBoundary wraps AppI18nProvider, so its fallback must still work
 * when that provider or any descendant has failed and been unmounted.
 */
export function getCrashRecoveryCopy(
    locale: MessageLocale = getStaticBuildLocale()
): CrashRecoveryCopy {
    const i18n = createAppI18n(locale);
    return {
        recovering: i18n._(crashRecoveryMessages.recovering),
        title: i18n._(crashRecoveryMessages.title),
        description: i18n._(crashRecoveryMessages.description),
        reload: i18n._(crashRecoveryMessages.reload),
    };
}
